import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from './setup';

/**
 * Check if app is Acquired
 * @param {object} params - an object of params
 * @param {string} params.accessToken - User IMS token
 * @param {string} params.appId - Id of the app
 */
export default async (params = {}, signal = null) => {
  const requiredParams = ['appId', 'accessToken'];
  const paramsRules = {
    appId: { allowedTypes: ['string'] },
    accessToken: { allowedTypes: ['string'] },
    linkedAppId: { allowedTypes: ['string'] },
    isTrial: { allowedTypes: ['boolean'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(
    `${settings.endpoint}/acquiredApps?appId=${params.appId}&api_key=${settings.apiKey}&linkedappid=${params.linkedAppId}&istrial=${params.isTrial}`,
    {
      signal,
      headers: { Authorization: params.accessToken },
    }
  );
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return Object.entries(content.apps)?.flat()?.includes(params.appId);
  }
};
